import * as net from "../vipa/net";

export class Case {
    cartItemRemoveAlertMessage = "Really want to remove this item from the cart?";
    crossReferenceAlertMessage = "Really want to set the item cross reference? Saved cross reference cannot be modified.";
    crossReferenceNotMatchAlertMessage = "Confirmation cross reference does not match.";

    constructor() {
        let ric = $("#cart-messages-remove-item-confirm").text();
        if (ric !== null && ric !== "") {
            this.cartItemRemoveAlertMessage = ric;
        }
        let cram = $("#cart-messages-cross-reference-confirm").text();
        if (cram !== null && cram !== "") {
            this.crossReferenceAlertMessage = cram;
        }
        let crnmam = $("#cart-messages-cross-reference-not-match-confirm").text();
        if (crnmam !== null && crnmam !== "") {
            this.crossReferenceNotMatchAlertMessage = crnmam;
        }

        $("#cart-items")
            .on("click", ".cart-updateItem", this.click)
            .on("keydown", ".cart-crossReference, .cart-note, .cart-quantity", this.enter)
            .on("keydown", ".cart-note", this.timedChange)
            .on("focusout", ".cart-crossReference, .cart-note, .cart-quantity", this.focusout)
            .on("change", ".cart-deliveryDate", this.dateChange)
            .on("change", ".cart-quantity", this.timedChange);
        $('[data-toggle="datepicker"]').each(function () {
            let startdate = null;
            if ($(this).data().hasOwnProperty("startdate")) {
                startdate = $(this).data().startdate;
            }
            // @ts-ignore
            $(this).datepicker({
                format: "yyyy-mm-dd",
                language: globalThis.langLocale,
                weekStart: 1,
                autoHide: true,
                startDate: startdate
            });
        });
    }

    changeTimer: Map<number, number> = new Map();

    timedChange = (event: JQuery.TriggeredEvent) => {
        let product_id: number = this.getProductId(event);
        let timer: number | undefined = this.changeTimer.get(product_id);
        if (timer !== undefined) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            $(`#cart-updateItem-${product_id}`).trigger("click");
            this.changeTimer.delete(product_id);
        }, 1000);
        this.changeTimer.set(product_id, timer);
    }

    dateChange = (event: JQuery.ChangeEvent) => {
        let product_id = this.getProductId(event);
        $(`#cart-updateItem-${product_id}`).trigger("click");
    }

    focusout = (event: JQuery.FocusOutEvent) => {
        event.preventDefault();
        let product_id = this.getProductId(event);
        this.changeTimer.delete(product_id);
        $(`#cart-updateItem-${product_id}`).trigger("click");
    }

    enter = (event: JQuery.KeyDownEvent) => {
        if (event.key === "Enter") {
            event.preventDefault();
            let product_id = this.getProductId(event);
            this.changeTimer.delete(product_id);
            $(`#cart-updateItem-${product_id}`).trigger("click");
        }
    }

    click = (event: JQuery.ClickEvent) => {
        let product_id = this.getProductId(event);
        let quantityInput = $(`#cart-quantity-${product_id}`);
        let quantity = String(quantityInput.val()).trim();
        let deliveryDateInput = $(`#cart-deliveryDate-${product_id}`);
        let deliveryDate = String(deliveryDateInput.val()).trim();
        let requested_delivery_date = String(deliveryDateInput.data().startdate).trim();
        let cross_reference = $(`#cart-crossReference-${product_id}`).val();
        let orig_cross_reference = $(`#cart-crossReference-${product_id}`).attr("data-orig");

        if (cross_reference !== orig_cross_reference) {
            let validation_cr = prompt(this.crossReferenceAlertMessage);
            if (validation_cr === null) {
                $(`#cart-crossReference-${product_id}`).val("");
                return
            } else if (validation_cr !== cross_reference) {
                alert(this.crossReferenceNotMatchAlertMessage);
                $(`#cart-crossReference-${product_id}`).trigger("focusout");
                return
            }
        }

        if (quantity == "") {
            let previousQuantity = quantityInput.attr("step");
            if (previousQuantity === undefined) {
                previousQuantity = "1";
            }
            quantityInput.val(previousQuantity);
            $(`#cart-updateItem-${product_id}`).trigger("click");
            return
        } else if (quantity == "0") {
            let ok = confirm(this.cartItemRemoveAlertMessage);
            if (!ok) {
                return
            }
        }

        let note = $(`#cart-note-${product_id}`).val();
        let data = {
            jsonrpc: "2.0",
            id: null,
            product_id: product_id,
            quantity: quantity,
            requested_delivery_date: requested_delivery_date,
            user_requested_date: deliveryDate,
            cross_reference: cross_reference,
            note: note
        }
        let url;
        if (globalThis.lang) {
            url = `/${globalThis.lang}/j/update-cart-item/`;
        } else {
            url = "/j/update-cart-item/";
        }
        net.postJSON(
            url,
            data,
            (data: any) => {
                this.clickSuccess(data.result, product_id)
            }
        ).fail(this.clickFail);
    }

    clickSuccess(result: JQuery.PlainObject, product_id: number): void {
        switch (result.action) {
            case "removed":
                let cart_count = $("#base-cartCount");
                cart_count.text(result.cart_count);

                let table = $("#cart-items").DataTable();
                let row = $(`#item-${product_id}`);
                row.hide("slow", () => { table.row(row).remove().draw(); });

                $("#cart-amount").text(result.total_amount);
                $("#cart-weight").text(result.total_weight);

                // Trace on analytics
                window.sa_event("remove_cart_item");
                break;
            case "updated":
                if (result.cross_reference) {
                    $(`#cart-crossReference-${product_id}`)
                        .val(result.cross_reference)
                        .attr("readonly", "readonly")
                        .attr("disabled", "disabled");
                }
                $(`#cart-amount-${product_id}`).text(result.amount);
                $(`#cart-discount-${product_id}`).text(result.discount);
                $(`#cart-weight-${product_id}`).text(result.weight);
                $(`#cart-quantity-${product_id}`).val(result.quantity);
                $(`#cart-availabilityColor-${product_id}`)
                    .removeClass("main-gray main-yellow main-red main-green")
                    .addClass(`main-${result.stock_color}`);
                $(`#cart-availability-${product_id}`)
                    .text(result.stock_tooltip);
                $(`.cart-availableQuantity-${product_id}`)
                    .text(result.available_quantity);
                $("#cart-amount").text(result.total_amount);
                $("#cart-weight").text(result.total_weight);

                let dpr = $(`#cart-deliveryDate-td-${product_id}`);
                dpr.attr("data-search", result.user_requested_date ?? result.delivery_date);
                dpr.attr("data-sort", result.user_requested_date ?? result.delivery_date);
                let dp = $(`#cart-deliveryDate-${product_id}`);
                // @ts-ignore
                $(dp).datepicker('setStartDate', result.delivery_date);
                dp.val(result.user_requested_date ?? result.delivery_date);
                dp.attr("value", result.user_requested_date ?? result.delivery_date);
                dp.attr("data-sort", result.user_requested_date ?? result.delivery_date);

                if (result.is_low_stock) {
                    $(`.cart-availabilityAlert-${product_id}`).show();
                    $(`#cart-availabilityOk-${product_id}`).hide();
                } else {
                    $(`.cart-availabilityAlert-${product_id}`).hide();
                    $(`#cart-availabilityOk-${product_id}`).show();
                }

                if (result.is_low_amount) {
                    $(`#cart-amountAlert-${product_id}`).show();
                } else {
                    $(`#cart-amountAlert-${product_id}`).hide();
                }

                let updated = $(`#cart-updated-${product_id}`);
                updated.show().delay(1000).fadeOut("slow");
                break;

        }
        if (result.low_amount_skus) {
            $("#cart-lowAmountWarningSkus").text(result.low_amount_skus);
            $("#cart-lowAmountWarning").show();
            $("#cart-send-order").attr("disabled", "true");
        } else {
            $("#cart-lowAmountWarningSkus").text("");
            $("#cart-lowAmountWarning").hide();
            $("#cart-send-order").removeAttr("disabled");
        }

        cartTable.cleanAllFilters();
        cartTable.createAllFilters()
    }

    clickFail(response: JQuery.jqXHR): void {
        let modal = $("#modal-small");
        let content = $("#modal-small div");

        content.html(response.responseJSON.error);
        modal.foundation("open");
        $(document).on('closed.zf.reveal', function () {
            location.reload();
        });
    }

    private getProductId(event: JQuery.TriggeredEvent): number {
        return $(event.currentTarget)
            .closest(".product")
            .data("id")
    }
}
